
/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import moment from "moment";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import Multiselect from "@vueform/multiselect";

export default {
    name: "ThresholdAddEditModal",
    components: { customModal, Multiselect },
    props: { data: Object },
    emits: ["closeModal", "save"],
    data() {
        return {
            form: this.data || {
                RiskID: "",
                RiskName: "",
                Thresholds: [],
                Unit: "",
                RiskLevelRules: [],
                Version: "1",
                IsActive: true,
                CriticalDataPoints: [],

            },
            thresholdError: "",
            riskRuleError: "",
            baseurl: process.env.VUE_APP_Service_URL,
            studyId: "",
            token: "",
            templates: [],
            templateFields: [],
            selectedTemplateId: "",
            selectedFields: [],
            maxVisibleFields: 3,
            errors: {
                RiskID: "",
                RiskName: ""
            },
            cdpError: "",
            ractlist: [],
            currentTemplatePage: 1,
            pagesize: 10,
            totalCount: 0,
            totalPages: 0,

            SortProperty: "",
            SortOrder: 0,
            riskOptions: [],

        };
    },
    async mounted() {
        window.addEventListener("studyIdChanged", () => {
            this.studyId = store.getters.getStudyIs;
            this.token = store.getters.getIdToken;
            this.loadTemplates();
        });
        this.studyId = store.getters.getStudyIs;
        this.token = store.getters.getIdToken;
        this.loadTemplates();
        this.getRactData();

    },
    computed: {
        isEditMode() {
            return !!this.data?.riskID;
        }
    },

    watch: {
        data: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (newVal && newVal.riskID) {
                    console.log("Edit mode detected via watcher", newVal);
                    this.mapEditData(newVal);
                }
            }
        }
    },

    methods: {
        closeModal() {
            this.$emit("closeModal");
        },
        visibleFields(c) {
            if (!Array.isArray(c.fieldLabels)) return [];
            if (c.showAll) return c.fieldLabels;
            return c.fieldLabels.slice(0, this.maxVisibleFields);
        },


        toggleFields(c) {
            c.showAll = !c.showAll;
        },
        onRiskChange(event) {
            const selectedId = event.target.value;

            const selected = this.riskOptions.find(
                r => r.value === selectedId
            );

            this.form.RiskID = selected?.value || "";
            this.form.RiskName = selected?.label || "";

            this.errors.RiskID = "";
            this.errors.RiskName = "";
        },



        async addThreshold() {
            const last = this.form.Thresholds[this.form.Thresholds.length - 1];

            if (last && !this.isThresholdValid(last)) {
                this.thresholdError = "Please complete the previous Threshold row.";
                return;
            }

            this.thresholdError = "";
            this.form.Thresholds.push({
                Min: "",
                Max: "",
                Probability: "",
                Impact: "",
                Detectibility: ""
            });
        },

        async removeThreshold(i) {
            this.form.Thresholds.splice(i, 1);
            this.thresholdError = "";
        },

        async isThresholdValid(t) {
            return (
                t.Min !== "" ||
                t.Max !== "" ||
                t.Probability !== "" ||
                t.Impact !== "" ||
                t.Detectibility !== ""
            );
        },

        async addRiskRule() {
            const last = this.form.RiskLevelRules[this.form.RiskLevelRules.length - 1];

            if (last && !this.isRiskRuleValid(last)) {
                this.riskRuleError = "Please complete the previous Risk Level Rule.";
                return;
            }

            this.riskRuleError = "";
            this.form.RiskLevelRules.push({
                ScoreRange: { Min: "", Max: "" },
                Label: "",
                Color: "#000000"
            });
        },

        async removeRiskRule(i) {
            this.form.RiskLevelRules.splice(i, 1);
            this.riskRuleError = "";
        },

        async isRiskRuleValid(r) {
            return (
                r.ScoreRange.Min !== "" ||
                r.ScoreRange.Max !== "" ||
                r.Label.trim() !== ""
            );
        },
        validateForm() {
            this.errors.RiskID = "";
            this.errors.RiskName = "";

            let isValid = true;

            if (!this.form.RiskID) {
                this.errors.RiskName = "Risk Name is required";
                isValid = false;
            }

            return isValid;
        },


        async save() {
            if (!this.validateForm()) return;
            try {
                const payload = {
                    riskID: this.form.RiskID,
                    riskName: this.form.RiskName,

                    criticalDataPoints: this.form.CriticalDataPoints.map(c => ({
                        formId: c.templateName,
                        fieldnames: c.fieldnames
                    })),

                    thresholds: this.form.Thresholds.map(t => ({
                        min: Number(t.Min),
                        max: Number(t.Max),
                        probability: Number(t.Probability),
                        impact: Number(t.Impact),
                        detectibility: Number(t.Detectibility)
                    })),

                    riskLevelRules: this.form.RiskLevelRules.map(r => ({
                        scoreRange: {
                            min: Number(r.ScoreRange.Min),
                            max: Number(r.ScoreRange.Max)
                        },
                        label: r.Label,
                        color: r.Color
                    })),

                    unit: this.form.Unit,
                    studyId: this.studyId,
                    version: this.form.Version,
                    isActive: this.form.IsActive
                };

                const config = {
                    headers: {
                        Authorization: `Bearer ${this.token}`
                    }
                };

                if (this.isEditMode) {
                    await axios.put(
                        `${this.baseurl}/forms/rbqm/updatethreshold`,
                        payload,
                        config
                    );
                } else {
                    await axios.post(
                        `${this.baseurl}/forms/rbqm/createthreshold`,
                        payload,
                        config
                    );
                }

                this.$emit("saveThreshold");
                alert("Risk Threshold saved successfully");
                this.closeModal();

            } catch (error) {
                console.error("Save Threshold failed:", error);
                alert("Failed to save Risk Threshold. Please try again.");
            }
        },

        async loadTemplates() {
            const res = await axios.get(
                `${this.baseurl}/forms/template/listtemplate`,
                {
                    params: {
                        StudyID: this.studyId
                    },
                    headers: {
                        Authorization: `Bearer ${this.token}`
                    }
                }
            );

            this.templates = res.data.results || [];
        },

        async onTemplateChange() {
            if (this.selectedTemplateId) {
                this.cdpError = "";
            }
            this.selectedFields = []
            this.templateFields = []

            if (!this.selectedTemplateId) return

            try {
                const res = await axios.get(
                    `${this.baseurl}/forms/template/get/${this.selectedTemplateId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${this.token}`
                        }
                    }
                )

                const pages = res.data.pages || []

                this.templateFields = pages.flatMap(p =>
                    (p.field || [])
                        .filter(f => !["header", "subHeader"].includes(f.type))
                        .map(f => ({
                            fieldName: f.fieldName,
                            label: f.label || f.fieldName
                        }))
                )

            } catch (err) {
                console.error("Failed to load template fields", err)
                this.templateFields = []
            }
        },



        async addCriticalDataPoint() {
            this.cdpError = "";

            if (!this.selectedTemplateId) {
                this.cdpError = "Please select a template";
                return;
            }

            const template = this.templates.find(t => t.templateId === this.selectedTemplateId);
            if (this.selectedFields.length) {
                const fieldnames = this.selectedFields.map(f => f.fieldName);
                const fieldLabels = this.selectedFields.map(f => f.label);

                this.form.CriticalDataPoints.push({
                    formId: template?.templateName,
                    templateName: template?.templateName,
                    fieldnames,
                    fieldLabels,
                    showAll: false
                });
                console.log(this.form.CriticalDataPoints, "critical data points");
            }
            else {
                this.form.CriticalDataPoints.push({
                    formId: template?.templateName,
                    templateName: template?.templateName,
                    fieldnames: [],
                    fieldLabels: [],
                    showAll: false
                });
            }


            this.selectedTemplateId = "";
            this.selectedFields = [];
            this.templateFields = [];
            console.log(this.form.CriticalDataPoints, "critical data points after reset");
        },



        async removeCriticalDataPoint(index) {
            this.form.CriticalDataPoints.splice(index, 1);
        },
        async mapEditData(data) {
            this.form = {
                RiskID: data.riskID,
                RiskName: data.riskName,
                Unit: data.unit,
                Version: data.version,
                IsActive: data.isActive,

                Thresholds: (data.thresholds || []).map(t => ({
                    Min: t.min,
                    Max: t.max,
                    Probability: t.probability,
                    Impact: t.impact,
                    Detectibility: t.detectibility
                })),

                RiskLevelRules: (data.riskLevelRules || []).map(r => ({
                    ScoreRange: {
                        Min: r.scoreRange.min,
                        Max: r.scoreRange.max
                    },
                    Label: r.label,
                    Color: r.color
                })),

                CriticalDataPoints: (data.criticalDataPoints || []).map(c => ({
                    formId: c.templateId,
                    templateName: c.templateName || "",
                    fieldnames: Array.isArray(c.fieldnames) ? c.fieldnames : [],
                    fieldLabels: Array.isArray(this.getFieldLabels(c.templateId, c.fieldnames))
                        ? this.getFieldLabels(c.templateId, c.fieldnames)
                        : [],
                    showAll: false
                }))

            };
        },
        getTemplateName(templateId) {
            const t = this.templates.find(x => x.templateId === templateId);
            return t?.templateName || "";
        },

        getFieldLabels(templateId, fieldnames) {
            if (!fieldnames) return null;

            const template = this.templates.find(t => t.templateId === templateId);
            if (!template || !template.pages) return fieldnames;

            const fields = template.pages.flatMap(p => p.field || []);
            return fieldnames.map(fn => {
                const f = fields.find(x => x.fieldName === fn);
                return f?.label || fn;
            });
        },
        async getRactData() {
            let idtoken = store.getters.getIdToken;

            await axios
                .get(
                    `${this.baseurl}/forms/rbqm/paginatedkri?` +
                    "&StudyId=" +
                    store.getters.getStudyIs +
                    "&SortProperty=" +
                    this.SortProperty +
                    "&SortOrder=" +
                    this.SortOrder,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then((res) => {
                    this.ractlist = res.data.entities;
                    this.riskOptions = this.ractlist
                        .filter(item =>
                            item.riskIndicator &&
                            item.riskIndicator.trim() !== ""
                        )
                        .sort((a, b) =>
                            a.riskIndicator.localeCompare(b.riskIndicator)
                        )
                        .map(item => ({
                            label: item.riskIndicator,
                            value: item.categoryId
                        }));
                })
                .catch((err) => {
                    console.log("error..", err);
                });
        },






    }

};